import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { ComponentProps } from "react";

import { useSearchBoxContext } from "@/components/Search/SearchBar/components/SearchBox/context/searchBox.context";
import { useSearchBarContext } from "@/components/Search/SearchBar/context/searchBar.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = ComponentProps<typeof Button>;

export const ResetButton = ({ className, children, ...props }: Props) => {
    const { resetButtonRef, onResetClick } = useSearchBoxContext();
    const { autocompleteState } = useSearchBarContext();
    const { t } = useGranite();

    if (!autocompleteState?.query) return;

    return (
        <Button
            {...props}
            className={cn(className)}
            ref={resetButtonRef}
            type={"reset"}
            onClick={onResetClick}
            tabIndex={0}
            aria-label={t("searchBox.input.button.reset")}
        >
            {children}
        </Button>
    );
};
